var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Checkbox, Dimmer, Form, Grid, Header, Loader } from 'semantic-ui-react';
import { AppPaths, UiConfigContext } from "../../AppConfig";
import { ORIGIN } from "../../Config";
import ErrorDisplay from "../../ErrorDisplay";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { buildOnComponentStateChangeHandler } from "../FormState";
import { HcrAmplifier } from "../rna-cish/RnaCatalog";
import { ManualProConsumerAmpForm } from "./ManualProConsumerAmpForm";
import BufferForm from "../rna-fish/BufferForm";
import { defaultBufferState, defaultProbeSetState, defaultSampleTypeState } from "../rna-fish/EditKitForm";
import ProbeSetForm from "../rna-fish/ProbeSetForm";
import SelectSampleTypeForm from "../rna-fish/SelectSampleTypeForm";
import { ErrorElements } from "../rna-fish/NewRnaFishKitPage";
import ManualProConsumerKitSerializer from "./ManualProConsumerKitSerializer";
export var defaultAmpState = function (catalog) {
    var _a, _b;
    return ({
        hcrAmplifier: new HcrAmplifier("X2"),
        scale: undefined,
        enzyme: (_a = catalog.manualProAmpCatalog.amplifierConfig.find(function (c) { return c.displayName === 'HRP'; })) !== null && _a !== void 0 ? _a : (function () {
            throw new Error("Required Pro amplifier config not found");
        })(),
        chromogen: (_b = catalog.cishChromogens.chromogens.find(function (c) { return c.id === 'MATISSE_BROWN'; })) !== null && _b !== void 0 ? _b : {
            id: 'NONE',
            label: 'NONE',
            protocolCompatibility: [],
            enzymeCompatibility: '',
            bufferCompatibility: { id: 'NONE', label: 'NONE' }
        }
    });
};
export var defaultFormState = function (catalog) { return ({
    ampEnabled: true,
    buffersEnabled: true,
    comment: '',
    errors: [],
    price: undefined,
    priceLoading: false,
    probeSetEnabled: true,
    ampState: defaultAmpState(catalog),
    bufferState: defaultBufferState(catalog, false, true),
    probeSetState: defaultProbeSetState(catalog, false, true),
    sampleTypeFormState: defaultSampleTypeState()
}); };
/**
 * For this to show up, make sure to wrap the EditKitForm in a Form who sets `error` when errors is non empty
 */
var EditKitForm = /** @class */ (function (_super) {
    __extends(EditKitForm, _super);
    function EditKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onAmpStateChange = buildOnComponentStateChangeHandler(ampStateWrangler, _this.props.setFormState);
        _this.onBufferStateChange = buildOnComponentStateChangeHandler(bufStateWrangler, _this.props.setFormState);
        _this.onSampleTypeStateChangeBaseHandler = buildOnComponentStateChangeHandler(sampleTypeStateWrangler, _this.props.setFormState);
        _this.onProbeSetEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeSetEnabled: !s.probeSetEnabled };
            }, function (newState) {
                // if probe set was just enabled, set the amplifier component's amplifier
                if (newState.probeSetEnabled) {
                    _this.onProbeSetStateChange({}, _this.props.formState.probeSetState.hcrAmplifier, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onProbeSetStateChange = function (updateObjOrFn, prevAmplifier, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.probeSetState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                probeSetState: Object.assign({}, oldState.probeSetState, stateCalculator(oldState))
            }); }, function (newState) {
                callback ? callback(newState) : {};
            });
        };
        _this.onAmplifierEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { ampEnabled: !s.ampEnabled };
            }, function (newState) {
                if (newState.ampEnabled) {
                    _this.onAmpStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onBuffersEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { buffersEnabled: !s.buffersEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        // Wrapper around normal state propagation to handle setting the wash buffer to 0 when northern blot is selected
        _this.onSampleTypeStateChange = function (sampleTypeFormState, prevSampleType, callback) {
            return _this.onSampleTypeStateChangeBaseHandler(sampleTypeFormState, function (newState) {
                var sampleType = newState.sampleTypeFormState.sampleType;
                if (sampleType.id === "WHOLE_MOUNT") {
                    _this.onAmpStateChange({
                        scale: _this.props.catalog.manualProAmpCatalog.defaultAmplifierScale
                    }, callback);
                }
                else if (!["TISSUE_SECTION", "CELLS_SLIDE"].includes(prevSampleType.id) &&
                    ["TISSUE_SECTION", "CELLS_SLIDE"].includes(sampleType.id)) {
                    _this.onAmpStateChange({
                        scale: _this.props.catalog.manualProAmpCatalog.amplifierScales.find(function (s) { return s === 10; })
                    }, callback);
                }
                else {
                    if (callback !== undefined) {
                        callback();
                    }
                }
            });
        };
        // The user finished editing something
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            // start by setting the state so that the callback will see the state after previous changes have applied
            _this.props.setFormState(function () { return ({ priceLoading: true }); }, function (newState) {
                var kitBody = EditKitForm.serializeManualProConsumerKit(newState);
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(kitBody))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElements(json.errors); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: undefined
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    EditKitForm.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var probePrice;
        var ampPrice;
        var bufferPrice;
        var kitPrice = this.props.formState.price ?
            this.props.formState.price.kitPrice.individualKitPrices.find(function (k) { return k.channel === 1; }) : undefined;
        if (kitPrice !== undefined) {
            probePrice = (_a = kitPrice.probeSetPrices.find(function (p) { return p.index === 1; })) === null || _a === void 0 ? void 0 : _a.priceCents;
            ampPrice =
                ((_c = (_b = kitPrice.amplifierPrices.find(function (p) { return p.index === 1; })) === null || _b === void 0 ? void 0 : _b.priceCents) !== null && _c !== void 0 ? _c : 0) +
                    ((_e = (_d = kitPrice.buffersPrices.find(function (p) { return p.index === 2; })) === null || _d === void 0 ? void 0 : _d.priceCents) !== null && _e !== void 0 ? _e : 0) +
                    ((_g = (_f = kitPrice.chromogenPrices.find(function (p) { return p.index === 1; })) === null || _f === void 0 ? void 0 : _f.priceCents) !== null && _g !== void 0 ? _g : 0);
            bufferPrice = (_h = kitPrice.buffersPrices.find(function (p) { return p.index === 1; })) === null || _h === void 0 ? void 0 : _h.priceCents;
        }
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement("div", null),
            React.createElement(Header, { className: "component-slider" },
                React.createElement("span", { className: 'sample-type-span' }, "Sample type")),
            React.createElement("div", { className: 'no-outline-kit-component' },
                React.createElement(SelectSampleTypeForm, { sampleTypeState: this.props.formState.sampleTypeFormState, sampleTypes: this.props.catalog.goldFishBuffer.sampleTypes, manualPro: true, onSampleTypeChange: this.onSampleTypeStateChange, onUserSelection: this.onUserSelection, showErrors: this.props.showErrors, errors: this.props.formState.errors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.probeSetEnabled, otherComponentStates: [this.props.formState.ampEnabled, this.props.formState.buffersEnabled], onChange: this.onProbeSetEnableChange, label: "HCR™ HiFi Probe", cish: false },
                React.createElement(ProbeSetForm, { catalog: this.props.catalog, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: this.props.enableProbeSetCustomScale, onProbeSetChange: this.onProbeSetStateChange, onUserSelection: this.onUserSelection, priceCents: probePrice, priceLoading: this.props.formState.priceLoading, probeSetState: this.props.formState.probeSetState, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, restrictCustomTargetProbeSetSizeToCatalog: this.props.restrictCustomTargetProbeSetSizeToCatalog, manualPro: true, legacy: false, showErrors: this.props.showErrors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.ampEnabled, otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.buffersEnabled], onChange: this.onAmplifierEnableChange, label: "HCR™ Pro Amplifier Kit", cish: false },
                React.createElement(ManualProConsumerAmpForm, { ampState: this.props.formState.ampState, catalog: this.props.catalog, errors: this.props.formState.errors, onAmpStateChange: this.onAmpStateChange, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, onUserSelection: this.onUserSelection, priceCents: ampPrice, priceLoading: this.props.formState.priceLoading, showErrors: this.props.showErrors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.buffersEnabled, otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled], onChange: this.onBuffersEnableChange, label: "HCR™ Buffers", cish: false },
                React.createElement(BufferForm, { sampleType: this.props.formState.sampleTypeFormState.sampleType, legacy: false, manualPro: true, bufferState: this.props.formState.bufferState, catalog: this.props.catalog.goldFishBuffer, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: this.props.enableBufferCustomScale, errors: this.props.formState.errors, onBufferChange: this.onBufferStateChange, onUserSelection: this.onUserSelection, priceCents: bufferPrice, priceLoading: this.props.formState.priceLoading, showErrors: this.props.showErrors })),
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { style: { fontFamily: 'Avenir Next' }, placeholder: 'Please share any instructions for probe design, ' +
                                    'order fulfillment, or other relevant details regarding this order. ' +
                                    'If you have a preferred transcriptome for probe design, ' +
                                    'let us know how we can access it.', value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { 
                        // apply padding that matches the kit component div padding
                        style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPriceCents)))));
    };
    EditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    EditKitForm.serializeManualProConsumerKit = function (formState) {
        var serializer = new ManualProConsumerKitSerializer();
        if (formState.probeSetEnabled) {
            serializer.setProbeSetState(formState.probeSetState);
        }
        if (formState.ampEnabled) {
            serializer.setAmplifier(formState.ampState);
        }
        if (formState.buffersEnabled) {
            serializer.setBuffers(formState.bufferState);
        }
        return serializer.serializeKit(formState.comment, formState.sampleTypeFormState.sampleType);
    };
    return EditKitForm;
}(React.PureComponent));
export default EditKitForm;
var PriceDisplay = /** @class */ (function (_super) {
    __extends(PriceDisplay, _super);
    function PriceDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceDisplay.prototype.render = function () {
        return React.createElement("div", null,
            React.createElement(Loader, { active: this.props.loading, inline: true, size: 'mini' }),
            "\u00A0 Price (USD): ",
            this.props.priceCents === undefined ? ' (pending)' : '$' +
                formatMonetaryDecimal(this.props.priceCents));
    };
    return PriceDisplay;
}(React.PureComponent));
export { PriceDisplay };
var ToggleableKitComponent = /** @class */ (function (_super) {
    __extends(ToggleableKitComponent, _super);
    function ToggleableKitComponent(props) {
        return _super.call(this, props) || this;
    }
    ToggleableKitComponent.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            !this.props.cish ?
                React.createElement(Header, { className: "component-slider" },
                    React.createElement(Grid, { columns: 2, stackable: true },
                        React.createElement(Grid.Column, null,
                            React.createElement("span", null, this.props.label)),
                        React.createElement(Grid.Column, { textAlign: 'right' },
                            React.createElement(Checkbox, { checked: this.props.componentEnabled, 
                                // lock this one on if all the others are disabled
                                disabled: this.props.componentEnabled && this.props.otherComponentStates.every(function (b) { return !b; }), onChange: this.props.onChange, toggle: true })))) :
                React.createElement(Header, { className: "cish-component-slider" },
                    React.createElement(Grid, { columns: 2, stackable: true },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null, this.props.componentEnabled && React.createElement("span", null, this.props.label)),
                            React.createElement(Grid.Column, { textAlign: 'right' },
                                React.createElement(Checkbox, { checked: this.props.componentEnabled, 
                                    // lock this one on if all the others are disabled
                                    disabled: (this.props.componentEnabled && this.props.otherComponentStates.every(function (b) { return !b; }) || this.props.disableToggle), 
                                    // zero width space label helps vertical alignment
                                    label: '\u00A0', onChange: this.props.onChange, toggle: true }))))),
            React.createElement(Dimmer.Dimmable, { dimmed: !this.props.componentEnabled, className: this.props.cish ? 'cish-admin-kit-component' : 'kit-component' },
                !this.props.cish ?
                    React.createElement(Dimmer, { active: !this.props.componentEnabled, inverted: true },
                        React.createElement(Header, null,
                            "No ",
                            this.props.label)) :
                    React.createElement(Dimmer, { className: 'dimmed-component', active: !this.props.componentEnabled, inverted: true },
                        React.createElement(Header, null,
                            "NO ",
                            this.props.label)),
                this.props.children));
    };
    return ToggleableKitComponent;
}(React.PureComponent));
export { ToggleableKitComponent };
export var priceColumn = function (priceNode) {
    return React.createElement(Grid.Column, { style: { 'position': 'relative' } },
        React.createElement("div", { style: {
                'position': 'absolute',
                'bottom': '0',
                // re-apply the padding for a Grid.Column
                'right': '1rem',
                'marginTop': '.5rem'
            } }, priceNode));
};
export var discountMessage = function (discountCents, listPriceCents) {
    return React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
        if (discountCents > 0) {
            return React.createElement("h5", { className: 'discount-msg' },
                "This reflects a discount of $",
                formatMonetaryDecimal(discountCents),
                " off the list price of $",
                formatMonetaryDecimal(listPriceCents));
        }
        else if (!(uiConfig.authenticated)) {
            if (ORIGIN === "mi") {
                return React.createElement("p", { className: 'discount-msg' },
                    React.createElement(Link, { to: AppPaths.REGISTER }, "Register"),
                    " to see applicable discounts");
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    });
};
export var formatMonetaryDecimal = function (cents) {
    if (cents < 0) {
        return "(" + (-cents / 100).toFixed(2) + ")";
    }
    return (cents / 100).toFixed(2);
};
var AmpStateWrangler = /** @class */ (function () {
    function AmpStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ ampState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.ampState; };
    }
    return AmpStateWrangler;
}());
var BufferStateWrangler = /** @class */ (function () {
    function BufferStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ bufferState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.bufferState; };
    }
    return BufferStateWrangler;
}());
var SampleTypeStateWrangler = /** @class */ (function () {
    function SampleTypeStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ sampleTypeFormState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.sampleTypeFormState; };
    }
    return SampleTypeStateWrangler;
}());
var ampStateWrangler = new AmpStateWrangler();
var bufStateWrangler = new BufferStateWrangler();
var sampleTypeStateWrangler = new SampleTypeStateWrangler();
//# sourceMappingURL=ManualProConsumerKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProConsumerKitForm.js
// module id = 113
// module chunks = 0